import { saveUserAction } from "actions";
import { createAlert } from "actions/alerts";
import { adaUploader } from "services/uploader";
import { updateOne } from "actions/resources";
import { getResource } from "selectors/resources";

/**
 * Change a fully authenticated user's password
 *
 * @param {string} oldPassword
 * @param {string} password
 * @param {string} userId
 * @returns {object}
 */
export function updatePassword(oldPassword, password, userId) {
  return {
    CALL_API: {
      method: "patch",
      endpoint: `/users/${userId}/password/`,
      payload: {
        old_password: oldPassword,
        new_password: password
      },
      args: {
        password
      },
      types: [
        "UPDATE_PASSWORD_REQUEST",
        "UPDATE_PASSWORD_SUCCESS",
        "UPDATE_PASSWORD_FAILURE"
      ],
      dispatchCallbacks: [
        {
          request: createAlert,
          fireOnStatus: 403,
          args: {
            message: "The password you entered was incorrect."
          }
        },
        {
          request: createAlert,
          fireOnStatus: 400
        },
        {
          request: createAlert,
          fireOnStatus: 200,
          args: {
            message: "Your password has been updated.",
            alertType: "success"
          }
        }
      ]
    }
  };
}

/**
 * AVATAR UPLOADER
 *
 * @param {File} file
 * @returns {AsyncAction}
 */
export function uploadAvatar(file) {
  const formData = new FormData();
  formData.append("file", file);

  return (dispatch, getState) => {
    /** @type User */
    const user = getResource(getState(), "user");

    dispatch({ type: "AVATAR_UPLOAD_REQUEST" });

    return adaUploader()
      .post("/images/", formData)
      .then((response) => {
        dispatch({ type: "AVATAR_UPLOAD_SUCCESS" });
        dispatch(updateOne("user", user.id, {
          profilePicture: response.data.url
        }));
        dispatch(saveUserAction(user.id));
      })
      .catch(() => {
        dispatch({ type: "AVATAR_UPLOAD_FAILURE" });
      });
  };
}
